var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIllu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.9 135.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    paintOrder: "fill markers stroke",
    transform: "translate(-13 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183.9,
    height: 40.6,
    x: 13,
    y: 8.9,
    ry: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 18.7h88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 18.7h27.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 25.6h50.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.6,
    d: "M19.5 25.4h20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 32.5H91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.9,
    d: "M19.7 32.4h24.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 39.3h40.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 39.3h27.1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.9,
    height: 40.6,
    x: 13,
    y: 56.6,
    ry: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 66.3h88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 66.3h27.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 73.2h50.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.6,
    d: "M19.5 73.2h20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 80H91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.9,
    d: "M19.7 80h24.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 87h40.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 87h27.1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.9,
    height: 40.6,
    x: 13,
    y: 104.2,
    ry: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 114h88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 114h27.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 120.8h50.9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.6,
    d: "M19.5 121h20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 127.7H91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2.9,
    d: "M19.7 127.8h24.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 2,
    d: "M61.3 134.6h40.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 0.7,
    strokeWidth: 3,
    d: "M19.7 134.6h27.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIllu);
export default __webpack_public_path__ + "static/media/dashboardIllu.ab1cdba2c42d2757dd8e620abc86ddb0.svg";
export { ForwardRef as ReactComponent };